<script setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  contactId: { type: [String, Number], default: null },
  conversationId: { type: [String, Number], default: null },
  kanbanItemId: { type: [String, Number], default: null },
});
const { t } = useI18n();
const orders = ref([]);
const loading = ref(true);
const error = ref(false);
const updating = ref(null);

const load = async () => {
  try {
    const accountId = window.chatwootConfig?.accountId;
    const params = {
      contact_id: props.contactId,
      conversation_id: props.conversationId,
    };
    const response = await window.axios.get(
      `/api/v1/accounts/${accountId}/sales/orders`,
      { params }
    );
    orders.value = response.data;
  } catch (exception) {
    error.value = true;
  } finally {
    loading.value = false;
  }
};

const updateLink = async order => {
  updating.value = order.id;
  try {
    const accountId = window.chatwootConfig?.accountId;
    await window.axios.patch(
      `/api/v1/accounts/${accountId}/sales/orders/${order.id}`,
      {
        order: {
          kanban_item_id: order.kanban_item_id ? null : props.kanbanItemId,
        },
      }
    );
    order.kanban_item_id = order.kanban_item_id ? null : props.kanbanItemId;
  } catch (exception) {
    error.value = true;
  } finally {
    updating.value = null;
  }
};

onMounted(load);
</script>

<template>
  <section class="p-3">
    <h3 class="mb-3 text-sm font-semibold text-n-800 dark:text-n-100">
      {{ t('SALES.TITLE') }}
    </h3>
    <p v-if="loading" class="text-sm text-n-500">{{ t('SALES.LOADING') }}</p>
    <p v-else-if="error" class="text-sm text-r-500">{{ t('SALES.ERROR') }}</p>
    <p v-else-if="!orders.length" class="text-sm text-n-500">
      {{ t('SALES.EMPTY') }}
    </p>
    <div
      v-for="order in orders"
      :key="order.id"
      type="button"
      class="flex w-full justify-between border-b border-n-weak py-2 text-left text-sm"
    >
      <span>{{ order.provider }}</span>
      <span class="flex items-center gap-2">
        {{ order.status }} {{ order.gross_amount }}
        <button
          v-if="kanbanItemId"
          type="button"
          class="text-xs text-woot-500"
          :disabled="updating === order.id"
          @click="updateLink(order)"
        >
          {{ order.kanban_item_id ? t('SALES.UNLINK') : t('SALES.LINK') }}
        </button>
      </span>
    </div>
  </section>
</template>
